import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFCPAP from '@/components/UI/svg/river2/Icon/EFCPAP';
import EFTank from '@/components/UI/svg/river2/Icon/EFTank';
import EFWifi from '@/components/UI/svg/river2/Icon/EFWifi';
import EFVideo from '@/components/UI/EFVideo';
import EcoImg from 'eco-design/base/eco-img';

// 视频是否已播放
let hasNoneEnterPlayFlag = true;

export default function Q() {
    const { useEffect, useLang, useState, useRouter, useRef } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const [isEnterA, setIsEnterA] = useState(false);
    const videoRefA = useRef();

    let controller: any;

    const videoMap: any = {
        us: ['/video/river2/details/10_us.webm', '/video/river2/details/10_us.mp4'],
        cn: ['/video/river2/details/10_cn.webm', '/video/river2/details/10_cn.mp4'],
        eu: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        de: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        fr: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        it: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        es: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        cis: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        jp: ['/video/river2/details/10_jp.webm', '/video/river2/details/10_jp.mp4'],
        uk: ['/video/river2/details/10_uk.webm', '/video/river2/details/10_uk.mp4'],
        za: ['/video/river2/details/10_za.webm', '/video/river2/details/10_za.mp4'],
        sa: ['/video/river2/details/10_uk.webm', '/video/river2/details/10_uk.mp4'],
        au: ['/video/river2/details/10_au.webm', '/video/river2/details/10_au.mp4'],
        kr: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
    };

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_J .sec2 .imgBox',
            triggerHook: 1,
            offset: 700,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            setIsEnterA(true);
            if (hasNoneEnterPlayFlag) {
                videoRefA.current?.play();
                hasNoneEnterPlayFlag = false;
            }
        });
        sceneA1.on('leave', () => {
            setIsEnterA(false);
        });
        controller.addScene(sceneA1);
    }, []);

    useEffect(() => {
        const videoDmo = document?.querySelector('#videoJ_A');
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_J .sec2 .imgBox',
            triggerHook: 1,
            offset: 0,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            if (videoDmo) {
                videoDmo.currentTime = 0;
                hasNoneEnterPlayFlag = true;
            }
        });
        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.J_10} river2_detials_J`}>
            <div className={`innerBox${isEnterA ? ' isEnterA' : ''}`}>
                {['eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca', 'ph'].includes(locale) && (
                    <div className="sec2">
                        <div className="textBox">
                            <div className="left">{t('river2.details.sec10_2_title')}</div>
                            <div className="right">
                                <p className="red">{t('river2.details.sec10_2_red')}</p>
                                <p className="text">{t('river2.details.sec10_2_desc')}</p>
                            </div>
                        </div>
                        <div className="image-warpper">
                            <div className="imgBox">
                                <div className="imgBox-in1">
                                    <div className="imgBox-in2">
                                        <div className="imgBox-in3">
                                            {locale === 'ph' ? (
                                                <EcoImg
                                                    pc="https://websiteoss.ecoflow.com/upload/image/1751271597670/b.jpg"
                                                    className="fullImgs"
                                                    ref={videoRefA}
                                                    id="videoJ_A"
                                                />
                                            ) : (
                                                <EFVideo
                                                    sources={videoMap[locale] || videoMap.us}
                                                    width="100%"
                                                    height="100%"
                                                    className="fullImgs"
                                                    loop={false}
                                                    autoPlay={false}
                                                    ref={videoRefA}
                                                    id="videoJ_A"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="icon-box">
                                {locale === 'ph' ? (
                                    <div className="right-icon-box">
                                        <div className="icon-box-item">
                                            <img src="https://websiteoss.ecoflow.com/upload/image/1751080550221/Fan.png" />
                                            <div className="text-box">{t('river2.details.sec10_2_icon1')}</div>
                                        </div>
                                        <div className="icon-box-item">
                                            <img src="https://websiteoss.ecoflow.com/upload/image/1751080550714/WIFI.png" />
                                            <div className="text-box">{t('river2.details.sec10_2_icon2')}</div>
                                        </div>
                                        <div className="icon-box-item">
                                            <img src="https://websiteoss.ecoflow.com/upload/image/1751080549949/Desktop.png" />
                                            <div className="text-box">{t('river2.details.sec10_2_icon3')}</div>
                                        </div>
                                        <div className="icon-box-item">
                                            <img src="https://websiteoss.ecoflow.com/upload/image/1751080550458/Refrigerator.png" />
                                            <div className="text-box">{t('river2.details.sec10_2_icon4')}</div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="right-icon-box">
                                        {locale !== 'jp' && (
                                            <div className="icon-box-item">
                                                <EFCPAP height="84px" width="84px" />
                                                <div className="text-box">{t('river2.details.sec10_2_icon1')}</div>
                                            </div>
                                        )}
                                        <div className="icon-box-item">
                                            <EFTank height="84px" width="84px" />
                                            <div className="text-box">{t('river2.details.sec10_2_icon2')}</div>
                                        </div>
                                        <div className="icon-box-item">
                                            <EFWifi height="84px" width="84px" />
                                            <div className="text-box">{t('river2.details.sec10_2_icon3')}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
